import gql from 'graphql-tag';

export const TransferBalance = gql`
  mutation prepaidsMerge($input: PrepaidsMergeInput!) {
    prepaidsMerge(input: $input) {
      beginBalance
      currencyCode
      currentBalance
      destinationCardNumber
      fdCorrelationId
      sourceCardNumber
      transactionId
    }
  }
`;
